import React, { useEffect, useState } from 'react';
import AdminCategoryCard from '../components/AdminCategoryCard';
import UploadCategory from '../components/UploadCategory';
import ReorderPopup from '../components/ReorderPopup';
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import SummaryApi from '../common';
import { toast } from 'react-toastify';

const AllCategory = () => {
  const [openUploadCategory, setOpenUploadCategory] = useState(false);
  const [openReorderPopup, setOpenReorderPopup] = useState(false);
  const [allCategory, setAllCategory] = useState([]);

  const fetchAllCategory = async () => {
    try {
      const response = await fetch(SummaryApi.adminCategory.url, {
        headers: {
          'Authorization': 'Bearer oakyaecom_no_units_916',
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch categories');
      }

      const dataResponse = await response.json();
      const reversedCategories = (dataResponse?.data || []).reverse();
      setAllCategory(reversedCategories);
    } catch (error) {
      console.error('Error fetching categories:', error);
      toast.error(`Failed to fetch categories: ${error.message}`);
    }
  };

  useEffect(() => {
    fetchAllCategory();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className='bg-white py-3 px-4 flex flex-col sm:flex-row justify-between items-center shadow-sm'>
        <h2 className='font-bold text-xl text-gray-800'>All Categories</h2>

        <div className='flex flex-wrap items-center gap-4 mt-3 sm:mt-0'>
          <div className='flex items-center text-sm text-gray-600'>
            <span>Active</span>
            <FaCheckCircle className='mx-2 text-lg text-green-600' />
            <span className='ml-3'>Inactive</span>
            <FaTimesCircle className='mx-2 text-lg text-red-600' />
          </div>

          <button
            className='border-2 border-red-600 text-red-600 hover:bg-red-600 hover:text-white transition-all py-1.5 px-4 rounded-full font-medium'
            onClick={() => setOpenUploadCategory(true)}
          >
            Upload Category
          </button>

          <button
            className='border-2 border-indigo-600 text-indigo-600 hover:bg-indigo-600 hover:text-white transition-all py-1.5 px-4 rounded-full font-medium'
            onClick={() => setOpenReorderPopup(true)}
          >
            Category Positions
          </button>
        </div>
      </div>

      {allCategory.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-20 px-4 text-center">
          <img
            src="https://img.freepik.com/free-vector/no-data-concept-illustration_114360-536.jpg"
            alt="No categories found"
            className="w-64 md:w-80 mb-6 opacity-90"
          />
          <h3 className="text-xl font-semibold text-gray-700 mb-3">
            No Categories Added Yet
          </h3>
          <p className="text-gray-500 mb-8 max-w-md">
            Start organizing your store by adding your first category using the button above.
          </p>
          <button
            className='bg-red-600 text-white hover:bg-red-700 transition-all py-3 px-8 rounded-full font-medium shadow-md'
            onClick={() => setOpenUploadCategory(true)}
          >
            Add Your First Category
          </button>
        </div>
      ) : (
        <div className='flex flex-wrap gap-5 py-6 px-4'>
          {allCategory.map((category, index) => (
            <AdminCategoryCard
              key={index}
              data={category}
              fetchdata={fetchAllCategory}
            />
          ))}
        </div>
      )}

      {openUploadCategory && (
        <UploadCategory
          onClose={() => setOpenUploadCategory(false)}
          fetchdata={fetchAllCategory}
        />
      )}

      {openReorderPopup && (
        <ReorderPopup
          onClose={() => setOpenReorderPopup(false)}
          fetchdata={fetchAllCategory}
        />
      )}
    </div>
  );
};

export default AllCategory;